import { FrontPagination } from "@shared/components";

export const GRAVIDADE_1_A_5 = [
    { title: "IDENTIFICANDO TRIAGEM...", color: "text-bg-secondary" },
    { title: "NÃO URGENTE", color: "text-bg-primary" },
    { title: "POUCO URGENTE", color: "text-bg-success" },
    { title: "URGENTE", color: "text-bg-warning" },
    { title: "MUITO URGENTE", color: "text-bg-orange" },
    { title: "EMERGÊNCIA", color: "text-bg-danger" },
];

export enum ConsultationStatusEncerramentoEnum {
    IN_PROGRESS = "IN_PROGRESS",
    FINISHED = "FINISHED",
}

export type CampoRevisavel = "queixaPrincipal" | "historiaDaDoenca" | "antecedentesPessoaisFamiliares" | "medicacaoUsoContinuo" | "hipotesesDiagnostica" | "condutaMedica";
export type CampoEditavelConsulta = CampoRevisavel | "exameFisico";
export type ConsultationProcessedField = string | string[];

export interface CampoAvaliacao {
    hasErro: boolean;
    expectedValue: string | string[];
    evaluatedBy?: string;
    evaluatedAt?: Date;
}

export interface Consultation {
    id: string;
    date?: string;
    finishedAt?: string;
    createdAt: string;
    statusEncerramento?: ConsultationStatusEncerramentoEnum;
    title?: string;

    patient: any;
    doctor: any;

    gravidade1a5?: string;
    queixaPrincipal?: string;
    historiaDaDoenca?: string;
    antecedentesPessoaisFamiliares?: string;
    medicacaoUsoContinuo?: string;
    hipotesesDiagnostica?: string[];
    cidProvavel?: string;
    cidDescricao?: string;
    condutaMedica?: string;
    insightNaoFeito?: string;
    nameDoctor?: string;
    emailDoctor?: string;
    exameFisico?: string;

    avaliacoes?: Partial<Record<CampoRevisavel, CampoAvaliacao>>;
    referenciasBibliograficas?: ReferenciaBibliografica[];
}

export interface ReferenciaBibliografica {
    bookTitle: string;
    authors: string[];
    edition: string | null;
    publisher: string | null;
    chapter: string | null;
    section: string | null;
    pageStart: number | null;
    pageEnd: number | null;
    formatted: string;
    content: string;
    score: number;
}

export interface ConsultationFilters {
    doctorId?: string;
    startDate?: string;
    endDate?: string;
    cid?: string;
    cidDescricao?: string;
}

export interface Transcription {
    consultation_id: string;
    created_at: string;
    issuer: "doctor" | "patient";
    sistema_de_origem: string;
    transcript_text: string;
    transcription_id: string;
}

export interface CurrentConsultationResponse {
    id?: string;
    createdAt?: string;
    finishedAt?: string | null;
    statusEncerramento?: ConsultationStatusEncerramentoEnum;
    patient?: {
        name?: string;
        nome?: string;
        cpf?: string;
        sex?: string;
        sexo?: string;
    };
    paciente?: {
        name?: string;
        nome?: string;
        cpf?: string;
        sex?: string;
        sexo?: string;
    };
    cpf?: string;
    sex?: string;
    sexo?: string;
    patientName?: string;
    patientCpf?: string;
    patientSex?: string;
    gravidade1a5?: number | string;
    queixaPrincipal?: ConsultationProcessedField;
    historiaDaDoenca?: ConsultationProcessedField;
    antecedentesPessoaisFamiliares?: ConsultationProcessedField;
    medicacaoUsoContinuo?: ConsultationProcessedField;
    hipotesesDiagnostica?: ConsultationProcessedField;
    condutaMedica?: ConsultationProcessedField;
    insightNaoFeito?: ConsultationProcessedField;
    exameFisico?: string;
}

export type TranscriptionsResponse = Transcription[] | { transcriptions?: Transcription[] };
